import React, { useEffect } from 'react';
import { Form, Row, Col, Container } from "react-bootstrap";
import { customValidators, object, string, date } from '../../../Helpers/Validators/customValidators';
import { sub } from 'date-fns';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { InputMaskDate } from '../../../Helpers/Formatters';
import SvgIcon from '@material-ui/core/SvgIcon';
import RingIcon from '../../../../icons/Ring.svg';
import BackNext from '../../Common/SubComponents/BackNext';
import '../Aflac.scss';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.js';
import { TextInput, StyledRadioInput } from '../../../Helpers/Inputs';
import MaleIcon from '../../../../icons/male.svg';
import FemaleIcon from '../../../../icons/female.svg';

export default function SpouseInfo(props) {

    const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
        validationSchema: SpouseInfo.ValidationSchema(props.ageSpecs),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });

    useEffect(() => {
        register({ name: 'firstName' });
        setValue('firstName', props.formState.firstName);

        register({ name: 'middleInitial' });
        setValue('middleInitial', props.formState.middleInitial);

        register({ name: 'lastName' });
        setValue('lastName', props.formState.lastName);

        register({ name: 'birthdate' });
        setValue('birthdate', props.formState.birthdate);

        register({ name: 'gender' });
        setValue('gender', props.formState.gender);

        register({ name: 'employmentStatus' });
        setValue('employmentStatus', props.formState.employmentStatus);

        register({ name: 'hospitalized' });
        setValue('hospitalized', props.formState.hospitalized);
    }, [register]);

    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };
    const onSubmit = () => {
        props.onNext();
    };

    const getDisabled = (props.formState.firstName === '' || props.formState.lastName === '' || props.formState.birthdate === '' || props.formState.gender === '' || props.formState.employmentStatus === '' ||
        (props.formState.employmentStatus === 'No' && props.formState.hospitalized === ''));

    return (
        <Container fluid className='border-class'>
            <Row className="justify-content-center">
                <Col>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Row className="justify-content-center mt-4">
                            <Col lg={6}>
                                <div className="text-center mb-2 pt-4"><SvgIcon component={RingIcon} className="small-icons" color="primary" fontSize="large" /></div>
                                <div className="text-center mb-4 form-title">Your Spouse's information</div>

                            </Col>
                        </Row>
                        <Row className="justify-content-center">
                            <Col lg={5}>
                                <Form.Group>
                                    <TextInput
                                        name="firstName"
                                        id="firstName"
                                        label="First Name"
                                        value={props.formState.firstName}
                                        errors={errors && errors.firstName}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('firstName', e.target.value)}
                                        inputProps={{
                                            maxLength: 20,
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="middleInitial"
                                        id="middleInitial"
                                        label="Middle Initial"
                                        value={props.formState.middleInitial}
                                        errors={errors && errors.middleInitial}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('middleInitial', e.target.value)}
                                        inputProps={{
                                            maxLength: 4,
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="lastName"
                                        id="lastName"
                                        label="Last Name"
                                        value={props.formState.lastName}
                                        errors={errors && errors.lastName}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('lastName', e.target.value)}
                                        inputProps={{
                                            maxLength: 50,
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <TextInput
                                        name="birthdate"
                                        id="birthdate"
                                        label="Date of Birth"
                                        value={props.formState.birthdate}
                                        errors={errors && errors.birthdate}
                                        inputRef={register}
                                        onChange={(e) => handleValueChange('birthdate', e.target.value)}
                                        InputProps={{
                                            inputComponent: InputMaskDate,
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <StyledRadioInput
                                        name="gender"
                                        id="gender"
                                        value={props.formState.gender}
                                        options={[{ value: "F", label: "Female", icon: <FemaleIcon /> }, { value: "M", label: "Male", icon: <MaleIcon /> }]}
                                        onChange={e => handleValueChange('gender', e)}
                                        errors={errors.gender}
                                    />
                                </Form.Group>

                                <h6 className='mb-3'>Is your spouse currently reporting to work (not out on leave,FML,disability,hiatus,or layoff)?</h6>
                                <Form.Group>
                                    <StyledRadioInput
                                        name="employmentStatus"
                                        id="employmentStatus"
                                        value={props.formState.employmentStatus}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('employmentStatus', e)}
                                        errors={errors.employmentStatus}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                {props.formState.employmentStatus === 'No' &&
                                    <div>
                                        <h6>Is your Spouse now hospitalized or unable to perform his or her normal duties and activities? </h6>
                                        <Form.Group>
                                            <StyledRadioInput
                                                name="hospitalized"
                                                id="hospitalized"
                                                value={props.formState.hospitalized}
                                                options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                                onChange={e => handleValueChange('hospitalized', e)}
                                                errors={errors.hospitalized}
                                                isWhiteBackground={true}
                                                isBlankIcon={true}
                                            />
                                        </Form.Group>
                                    </div>
                                }
                            </Col>
                        </Row>
                        <div className='backnext-wrapper'>
                            <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} nextDisabled={getDisabled} />
                        </div>
                    </Form>
                </Col>
            </Row>
        </Container >

    );
}

SpouseInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

SpouseInfo.ValidationSchema = (ageSpecs) => {
    return object().shape({
        firstName: customValidators.string().isValidNameWithFiftyChar('First name is required.', true),
        middleInitial: customValidators.string().isValidNameWithFiftyChar('Middle Initials is required', false),
        lastName: customValidators.string().isValidNameWithFiftyChar('Last name is required.', true),
        birthdate: date().transform(emptyStringToUndefined).typeError('Invalid date.')
            .max(sub(new Date(), { years: ageSpecs.min, days: ageSpecs.minAgeDays || 0 }), `Product not available due to age restrictions.`)
            .min(sub(new Date(), { years: ageSpecs.max }), `Product not available due to age restrictions.`)
            .required('Birthdate is required.'),
        gender: string().required('Gender is required.'),
        employmentStatus: string().required('Employment Status is required.'),
        hospitalized: string().when('employmentStatus', {
            is: "No",
            then: string().required("Hospitalized Status is required."),
            otherwise: string().notRequired(),
        }),
    })

};

SpouseInfo.DefaultFormState = (prefill = false) => {
    return {
        firstName: prefill ? 'Alex' : '',
        middleInitial: prefill ? 'Elizabeth' : '',
        lastName: prefill ? 'Smith' : "",
        birthdate: prefill ? "11/15/1980" : "",
        gender: prefill ? "F" : "",
        employmentStatus: prefill ? "Yes" : "",
        hospitalized: prefill ? "" : "",

    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/SpouseInfo.js